import { render } from "./PolicyReview.vue?vue&type=template&id=05a38d79&scoped=true"
import script from "./PolicyReview.vue?vue&type=script&lang=js"
export * from "./PolicyReview.vue?vue&type=script&lang=js"

import "./PolicyReview.vue?vue&type=style&index=0&id=05a38d79&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a38d79"]])

export default __exports__